import {
  resolveContentBlocks,
  resolveImage,
  resolveLink,
  resolveRTC,
  resolveDocumentUrl,
  resolveDate,
  resolveBool,
  resolveImageReference,
} from './resolvers';

export const CTADocumentMapping = {
  logo: [null, resolveImage],
  heading: null, // TODO: This value will eventually be a string
  subheading: null,
  detailContent: [null, resolveRTC],
  primaryCTA: [null, resolveLink],
  secondaryCTA: [null, resolveLink],
  backgroundImage: [null, resolveImage],
  mobileBackgroundImage: [null, resolveImage],
};

export const ContentListDocumentMapping = {
  listSuperheading: null,
  listTitle: null,
  contentList: [null, resolveContentBlocks],
  cta: [null, resolveLink],
};

export const FeaturedDocumentMapping = {
  title: 'title',
  headline: 'headline',
  imagecompound: ['image', resolveImage],
  cardTileImage: ['cardTileImage', resolveImage],
  publicationDate: ['cardPublicationDate', resolveDate],
  _links: ['url', resolveDocumentUrl],
  shortDescription: [null, resolveRTC],
};

export const MetadataDocumentMapping = {
  metaTitle: null,
  description: null,
  canonicalUrl: null,
  vanityUrl: null,
  metaKeywords: null,
  noFollow: [null, resolveBool],
  noIndex: [null, resolveBool],
  socialMediaDesc: null,
  socialMediaImage: [null, resolveImageReference],
  searchDisplayTitle: null,
  searchDisplayDescription: null,
  searchDisplayIcon: [null, resolveImageReference],
  locale: 'langCode',
  hreflangUrl: null,
};
